module.exports = __webpack_public_path__ + "static/media/LokiFrame88.ba8d5823.png";